import { TeamAccessGuard } from '@/components/auth/TeamAccessGuard';
import { SchedulingPreferencesForm } from '@/components/teams/SchedulingPreferencesForm';
import { NotificationPreferencesForm } from '@/components/teams/NotificationPreferencesForm';
import { TeamSettingsTabs } from '@/components/teams/TeamSettingsTabs';

export const TeamPreferencesPage = () => {
  return (
    <TeamAccessGuard>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold mb-6">Team Preferences</h1>
        
        <TeamSettingsTabs />
        
        <div className="space-y-8">
          <SchedulingPreferencesForm />
          
          <NotificationPreferencesForm />
        </div>
      </div>
    </TeamAccessGuard>
  );
}; 